import React from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { MEAL_MANAGE_PATH } from '@constant'
import { Link } from 'react-router'

export default () => {
  let header = [<Link to={MEAL_MANAGE_PATH}>套餐管理</Link>, '相关案例']
  const merchant_id = JSON.parse(sessionStorage.getItem('merchant_info'))
    .property_id
  return (
    <HeaderView title="相关案例" header={header}>
      <div className={styles.wrap}>
        <Link to={MEAL_MANAGE_PATH}>
          <img src="//qnm.hunliji.com/o_1d1t940gfi3b7rpretc4us53e.png" />
        </Link>

        <img
          src={
            merchant_id != 6
              ? '//qnm.hunliji.com/o_1d1v5h0hh11hk1rd61hm91dlc17m29.png'
              : '//qnm.hunliji.com/o_1c6tlkpic1r46dcirqvh012gkc.png'
          }
        />
        <img src="//qnm.hunliji.com/o_1d21r8idtff81mhvnp012ks1k1q9.png" />
      </div>
      <div className={styles.btnBox}>
        <Link to={MEAL_MANAGE_PATH}>去设置</Link>
      </div>
    </HeaderView>
  )
}
